import React from 'react';
import Link from 'next/link';
import { useTracking } from '../../features/Tracking';
import { fixHref } from './utils';
import { InteractiveElementType } from '@spotify-internal/frodor-modules';

const inProductUrl = 'https://artists.spotify.com/c';

// customComponent element MUST support a component prop
// to allow for passthrough of the Link
// encore interactive elements already do
export const InteractiveElement: InteractiveElementType = ({
  customComponent,
  href,
  children,
  trackingCategory,
  trackingLabel,
  onClick,
  ...rest
}) => {
  const { sendEvent } = useTracking();
  const fixedHref = fixHref(href);
  const onInteraciveElementClick = (e: React.MouseEvent) => {
    sendEvent({
      eventCategory: trackingCategory,
      eventAction: 'click',
      eventLabel: trackingLabel,
    });
    onClick && onClick(e);
  };

  // in product links should not use nextlink
  if (
    href &&
    (fixedHref?.startsWith(inProductUrl.concat('/')) ||
      fixedHref === inProductUrl)
  ) {
    if (customComponent) {
      const Component = customComponent;
      return (
        <Component
          href={fixedHref}
          {...rest}
          onClick={onInteraciveElementClick}
          target="_self"
        >
          {children}
        </Component>
      );
    }
    return (
      <a href={fixedHref} {...rest} onClick={onInteraciveElementClick}>
        {children}
      </a>
    );
  }
  const isExternalUrl = fixedHref && /^https?:\/\//.test(fixedHref);

  if (isExternalUrl) {
    if (customComponent) {
      const Component = customComponent;
      return (
        <Component
          href={fixedHref}
          {...rest}
          onClick={onInteraciveElementClick}
        >
          {children}
        </Component>
      );
    }
    return (
      <a href={fixedHref} {...rest} onClick={onInteraciveElementClick}>
        {children}
      </a>
    );
  }

  // non dashboard links can use nextlink
  if (customComponent) {
    const Component = customComponent;
    return (
      <Component
        component={href && Link}
        href={fixedHref}
        {...rest}
        onClick={onInteraciveElementClick}
      >
        {children}
      </Component>
    );
  } else if (fixedHref) {
    return (
      <Link href={fixedHref} {...rest} onClick={onInteraciveElementClick}>
        {children}
      </Link>
    );
  }
  return (
    <button {...rest} onClick={onInteraciveElementClick}>
      {children}
    </button>
  );
};
